export default "__VITE_ASSET__OzC87jca__"